import {connect} from 'react-redux';
import AlertBar from '../components/AlertBar.jsx';

const mapStateToProps = state => ({
  bar: state.alerts.bar,
  barEnabled: state.alerts.barEnabled,
});

const mapDispatchToProps = dispatch => ({
  onRemoveClick() {
    return dispatch({type: 'ALERT_BAR_HIDE'});
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertBar);
